import React, { Component } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "./Pages/Home";
import Raffle from "./Pages/Raffle";
import RafflePage from './Pages/RafflePage';
import CreateRaffle from './Pages/createRaffle';
import MyRaffles from './Pages/myRaffles';
import OwnerReportedRaffles from './Pages/ownerReportedRaffles';
import MyInvestment from './Pages/myInvestment';
 
function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path="/raffle/:id" element={<RafflePage />} />
					<Route path="/my-raffles" element={<MyRaffles />} />
					<Route path='/raffles' element={<Raffle />} />
					<Route path='/create-raffle' element={<CreateRaffle />} />
 					<Route path='/purchased-raffles' element={<MyInvestment />} />
 
				</Routes>
			</BrowserRouter>
			<div>
		

			</div>
		</div>




	)
}


export default App;
